// extracted by mini-css-extract-plugin
export var bodySections = "_9v-8";
export var gray = "_9v-7";
export var green = "_9v-4";
export var iconContainer = "_9v-9";
export var iconWidgetContainer = "_9v-1";
export var phoneIcon = "_9v-2";
export var red = "_9v-5";
export var statusDot = "_9v-3";
export var widgetContainer = "_9v-0";
export var yellow = "_9v-6";